var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.text && _vm.config.promoCode)?_c('div',{staticClass:"warningBox"},[_c('p',{staticClass:"warningBox__text"},[_vm._v(_vm._s(_vm.config.text))]),_c('p',{staticClass:"warningBox__cupom"},[_vm._v("Cupom: "),_c('strong',[_vm._v(_vm._s(_vm.config.promoCode))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }